
<template>
  <div ref="VChartComponentWrap" class="VChartComponentWrap">
    <div ref="header" class="VChartComponentWrap__header">
      <div class="title">{{ element.title }}</div>
      <div v-if="element.componentType === 'TowerWarning'" class="wrapping">
        <div class="item">
          <div class="txt" :style="`font-size: ${changeDevicePixelRatio(12)}px;`">报警塔机数</div>
          <div class="num">{{ countData.alarmDeviceCount }}</div>
        </div>
        <div class="item">
          <div class="txt" :style="`font-size: ${changeDevicePixelRatio(12)}px;`">报警总次数</div>
          <div class="num">{{ countData.alarmSumCount }}</div>
        </div>
      </div>
      <div v-if="element.componentType === 'TowerError'" class="wrapping">
        <div class="item">
          <div class="txt" :style="`font-size: ${changeDevicePixelRatio(12)}px;`">故障塔机数</div>
          <div class="num">{{ countData.errorDeviceCount }}</div>
        </div>
        <div class="item">
          <div class="txt" :style="`font-size: ${changeDevicePixelRatio(12)}px;`">故障总次数</div>
          <div class="num">{{ countData.errorSumCount }}</div>
        </div>
      </div>
      <div v-if="element.componentType === 'LiftWarning'" class="wrapping">
        <div class="item">
          <div class="txt" :style="`font-size: ${changeDevicePixelRatio(12)}px;`">报警升降机数</div>
          <div class="num">{{ countData.alarmDeviceCount }}</div>
        </div>
        <div class="item">
          <div class="txt" :style="`font-size: ${changeDevicePixelRatio(12)}px;`">报警总次数</div>
          <div class="num">{{ countData.alarmSumCount }}</div>
        </div>
      </div>
      <div v-if="element.componentType === 'LiftError'" class="wrapping">
        <div class="item">
          <div class="txt" :style="`font-size: ${changeDevicePixelRatio(12)}px;`">故障升降机数</div>
          <div class="num">{{ countData.errorDeviceCount }}</div>
        </div>
        <div class="item">
          <div class="txt" :style="`font-size: ${changeDevicePixelRatio(12)}px;`">故障总次数</div>
          <div class="num">{{ countData.errorSumCount }}</div>
        </div>
      </div>
      <div v-if="element.componentType === 'Overview'" class="wrapping">
        <div class="item">
          <div class="txt" :style="`font-size: ${changeDevicePixelRatio(12)}px;`">在场车队</div>
          <div class="num">{{ countData.inMcCount }}</div>
        </div>
        <div class="item">
          <div class="txt" :style="`font-size: ${changeDevicePixelRatio(12)}px;`">在场车辆</div>
          <div class="num">{{ countData.inLpCount }}</div>
        </div>
      </div>
      <div v-if="element.componentType === 'InOut'" class="wrapping">
        <div class="item">
          <div class="txt" :style="`font-size: ${changeDevicePixelRatio(12)}px;`">进场车次</div>
          <div class="num">{{ countData.inTrainSumCount }}</div>
        </div>
        <div class="item">
          <div class="txt" :style="`font-size: ${changeDevicePixelRatio(12)}px;`">出场车次</div>
          <div class="num">{{ countData.outTrainSumCount }}</div>
        </div>
      </div>
    </div>
    <div ref="chartWrap" class="chartWrap">
      <VchartComponent ref="VchartComponent" v-bind="$attrs" :element="element" :prop-value="propValue" />
    </div>
  </div>
</template>

<script>
import VchartComponent from './VChartComponent.vue'
import {
  queryAlarmErrorData,
  siteElevatorDeviceData,
  queryTrainData,
  queryMotorcadeData
} from '@/api/manage'
import moment from 'moment'
import { mapState } from 'vuex'
import { changeDevicePixelRatio } from '@/utils/changeComponentsSizeWithScale'
import _ from 'lodash'
export default {
  components: { VchartComponent },
  props: {
    element: {
      type: Object,
      default: () => {}
    },
    propValue: {
      type: Object,
      require: true,
      default: () => {}
    },
    personData: {
      type: Object,
      default: () => { return {} }
    },
    areaId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      apiList: {
        TowerWarning: {
          api: queryAlarmErrorData
        },
        TowerError: {
          api: queryAlarmErrorData
        },
        LiftWarning: {
          api: siteElevatorDeviceData
        },
        LiftError: {
          api: siteElevatorDeviceData
        },
        Overview: {
          api: queryMotorcadeData
        },
        InOut: {
          api: queryTrainData
        }
      },
      countData: {
        alarmDeviceCount: 0,
        alarmSumCount: 0,
        errorDeviceCount: 0,
        errorSumCount: 0,
        inMcCount: 0,
        inLpCount: 0,
        inTrainSumCount: 0,
        outTrainSumCount: 0
      }
    }
  },
  computed: {
    ...mapState({
      projectItem: state => state.user.projectItem,
      lrpEquipmentTimeLog: state => state.socket.lrpEquipmentTimeLog
    }),
    titleFontSize() {
      const px = Math.ceil(16 / window.devicePixelRatio)
      return px
    },
    rateFontSize() {
      const px = Math.ceil(26 / window.devicePixelRatio)
      return px
    }
  },
  watch: {
    'element.style': {
      deep: true,
      handler(val) {
        this.setHeight()
      }
    },
    lrpEquipmentTimeLog() {
      this.getData()
    }
  },

  created() {
    if (this.element.componentType === 'Overview' || this.element.componentType === 'InOut') {
      this.getData = _.throttle(this.getData, 3000, { leading: true, trailing: false })
    } else {
      this.timer = setInterval(() => {
        this.getData()
      }, 30000)
    }
    this.getData()
  },
  destroyed() {
    clearInterval(this.timer)
  },
  mounted() {
    this.setHeight = _.debounce(this.setHeight, 300)
    this.setHeight()
  },
  methods: {
    setHeight() {
      const height = this.$refs.VChartComponentWrap.clientHeight - this.$refs.header.clientHeight
      this.$refs.chartWrap.style.height = height + 'px'
      this.$refs.VchartComponent.render()
    },
    changeDevicePixelRatio,
    setAttendanceRate() {
      if (this.element.componentType === 'AttendanceRate') {
        this.propValue.option.series[0].data[0].value = this.personData.onJobCount - this.personData.inCount
        this.propValue.option.series[0].data[1].value = this.personData.inCount
        this.$refs.VchartComponent.render()
      }
    },
    getData() {
      const form = {
        month: moment().format('YYYY-MM'),
        pageNumber: 1,
        pageSize: 10,
        projectId: this.projectItem.projectId,
        areaId: this.areaId
      }
      this.apiList[this.element.componentType] && this.apiList[this.element.componentType].api(form).then(res => {
        this.countData = res.data
        if (this.element.componentType === 'TowerWarning' || this.element.componentType === 'LiftWarning') {
          const alarmDeviceData = res.data.deviceDataMap.alarmDeviceData
          if (alarmDeviceData) {
            for (const key in alarmDeviceData) {
              const arr = []
              if (Object.hasOwnProperty.call(alarmDeviceData, key)) {
                const element = alarmDeviceData[key]
                arr.push({
                  name: key,
                  value: element
                })
              }
              this.$set(this.propValue.option.series[0], 'data', arr)
            }
          }
        }
        if (this.element.componentType === 'TowerError' || this.element.componentType === 'LiftError') {
          const errorDeviceData = res.data.deviceDataMap.errorDeviceData
          if (errorDeviceData) {
            for (const key in errorDeviceData) {
              const arr = []
              if (Object.hasOwnProperty.call(errorDeviceData, key)) {
                const element = errorDeviceData[key]
                arr.push({
                  name: key,
                  value: element
                })
              }
              this.$set(this.propValue.option.series[0], 'data', arr)
            }
          }
        }
        if (this.element.componentType === 'Overview') {
          const mcData = res.data.mcData
          const xData = Object.keys(mcData)
          const mcInLpCount = []
          const mcLpCount = []
          for (const key in mcData) {
            if (Object.hasOwnProperty.call(mcData, key)) {
              const element = mcData[key]
              mcInLpCount.push(element.mcInLpCount)
              mcLpCount.push(element.mcLpCount)
            }
          }
          this.$set(this.propValue.option.xAxis[0], 'data', xData)
          this.$set(this.propValue.option.series[0], 'data', mcLpCount)
          this.$set(this.propValue.option.series[1], 'data', mcInLpCount)
        }
        if (this.element.componentType === 'InOut') {
          const dataMap = res.data.dataMap
          const xData = Object.keys(dataMap)
          xData.sort(function(a, b) {
            return a - b
          })
          const inTrainCount = []
          const outTrainCount = []
          xData.forEach(key => {
            const element = dataMap[key]
            inTrainCount.push(element.inTrainCount)
            outTrainCount.push(element.outTrainCount)
          })

          this.$set(this.propValue.option.xAxis[0], 'data', xData)
          this.$set(this.propValue.option.series[0], 'data', inTrainCount)
          this.$set(this.propValue.option.series[1], 'data', outTrainCount)
        }
        // if (this.element.componentType === 'InsidePersonCount') {
        //   this.$set(this.propValue.option.xAxis[0], 'data', res.data.map(item => item.hour))
        //   this.$set(this.propValue.option.series[0], 'data', res.data.map(item => item.workerCount))
        //   this.$set(this.propValue.option.series[1], 'data', res.data.map(item => item.managerCount))
        // } else if (this.element.componentType === 'InOutPersonCount') {
        //   this.$set(this.propValue.option.xAxis[0], 'data', res.data.map(item => item.hour))
        //   this.$set(this.propValue.option.series[0], 'data', res.data.map(item => item.inCount))
        //   this.$set(this.propValue.option.series[1], 'data', res.data.map(item => item.outCount))
        // } else if (this.element.componentType === 'AttendanceTeam') {
        //   this.$set(this.propValue.option.xAxis[0], 'data', res.data.map(item => item.teamName))
        //   this.$set(this.propValue.option.series[0], 'data', res.data.map(item => item.personCount))
        //   this.$set(this.propValue.option.series[1], 'data', res.data.map(item => item.verifyCount))
        // } else if (this.element.componentType === 'AttendanceWokerType') {
        //   this.$set(this.propValue.option.xAxis[0], 'data', res.data.map(item => item.workerTypeName))
        //   this.$set(this.propValue.option.series[0], 'data', res.data.map(item => item.personCount))
        //   this.$set(this.propValue.option.series[1], 'data', res.data.map(item => item.verifyCount))
        // }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.VChartComponentWrap{
  width: 100%;
  height: 100%;
  position: relative;
  .title{
    color: #00ccff;
    font-weight: bold;
    text-align: center;
    padding: 2% 0;
  }
  .wrapping{
    display: flex;
    justify-content: center;
    .item{
      text-align: center;
      color: #fff;
      width: 38%;
      border-radius: 4px;
      padding: 2% 0;
      background: #00448d;
      &:first-child{
        margin-right: 4%;
      }
    }
  }
  .chartWrap{
    width: 100%;
    height: calc(100% -20%);
  }
}
</style>
